import './response-message-view.component.ajscss';

import { IRecordDeprecatedService } from '@agent/core/phone/record-deprecated.service';
import { ToastDeprecatedService } from '@commons/core/notification/toast-deprecated.service';
import { Audio } from '@commons/toolbox/media-player/models/audio';
import { IResponderService } from '@responder/responder.service';
import { IComponentController, IComponentOptions } from 'angular';

import { DisplayDeprecatedComponent, Option, ToastClass, ToastType } from '@contact/upgrade';

import templateUrl from './response-message-view.component.ajs.html';

class ResponseMessageViewCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public onAudioUpdated: Function;

  protected urlResp;
  protected respDetailState;
  protected firstSearch;
  protected currentRespDetail;
  protected filters: any;
  protected today: Date;
  protected modelRespDetail: any;
  protected allPerimeter: string;

  // Init Hours Spinner
  protected stepHour;
  protected stepMinute;
  protected todayDateTime;
  protected beginDateTime;
  protected hoursBegin;
  protected minutesBegin;
  protected endDateTime;
  protected hoursEnd;
  protected minutesEnd;
  protected durationTime;
  protected minutesTime;
  protected secondsTime;
  protected minutesDuration;
  protected secondsDuration;
  protected hasBeginDate;
  protected hasEndDate;

  protected columns: any[] = [];
  protected rows: any[] = [];

  protected flowsList;
  protected columnFilterState;

  protected maxChecked: number;
  protected checked: number;

  constructor(
    private readonly toastDeprecatedService: ToastDeprecatedService,
    private readonly responder: IResponderService,
    private readonly recordDeprecatedService: IRecordDeprecatedService
  ) {
    super();
  }

  $onInit() {
    this.recordDeprecatedService
      .getRecordDownloadUrl()
      .subscribe(url => (this.urlResp = url.replace('record/downloadRecord', 'responder/downloadRespMessage')));

    this.respDetailState = false;
    this.firstSearch = true;
    this.currentRespDetail = null;
    this.filters = {
      phoneCallerFilter: '',
      calledPhoneFilter: '',
      calledPhoneAliasFilter: '',
      flowFilter: '',
      beginDateFilter: null,
      endDateFilter: null,
      durationFilter: '',
    };

    // init : ouverture de la page et affichage des messages de la journee en cours
    this.today = new Date();
    this.today.setHours(0);
    this.today.setMinutes(0);
    this.filters.beginDateFilter = this.today;

    this.modelRespDetail = {
      date: '',
      callerPhoneNumber: '',
      calledPhoneNumber: '',
      calledPhoneNumberAlias: '',
      duration: '',
      flow: '',
    };

    // Init Hours Spinner
    this.stepHour = 1;
    this.stepMinute = 5;
    this.todayDateTime = new Date();

    this.beginDateTime = new Date();
    this.hoursBegin = 0;
    this.minutesBegin = 0;
    this.beginDateTime.setHours(this.hoursBegin);
    this.beginDateTime.setMinutes(this.minutesBegin);

    this.endDateTime = new Date();
    this.hoursEnd = this.endDateTime.getHours();
    this.minutesEnd = this.endDateTime.getMinutes();

    this.durationTime = -1;
    this.minutesTime = 0;
    this.secondsTime = 0;

    this.columns = [
      { name: 'date' },
      { name: 'callerPhoneNumber' },
      { name: 'calledPhoneNumber' },
      { name: 'calledPhoneNumberAlias' },
      { name: 'calledFlow' },
      { name: 'duration' },
      { name: 'readStatus' },
    ];
    this.rows = [];

    this.maxChecked = 2;
    this.checked = 0;
    this.allPerimeter = '';

    this.responder.getPerimeters().then(
      perimeters => {
        this.allPerimeter = perimeters;
        // need $scope.allPerimeter defined to apply perimeters in request
        this.responder.getFlows().then(
          flows => {
            this.flowsList = Option.of(flows)
              .flatMap(list => Option.of(list.data))
              .map(list => list.map(flow => this.convertToFlowsList(flow)))
              .getOrElse([]);
            this.getRespMessagesList();
          },
          () => {
            this.flowsList = [];
            this.getRespMessagesList();
          }
        );
      },
      () => (this.allPerimeter = '')
    );
  }

  override onWatchSize(size: string) {
    if (size !== undefined) {
      switch (size) {
        case 'xsmall':
          this.maxChecked = 2;
          break;
        case 'small':
          this.maxChecked = 4;
          break;
        case 'medium':
          this.maxChecked = 6;
          break;
        case 'large':
          this.maxChecked = 10;
          break;
        default:
          this.maxChecked = 5;
          break;
      }
      this.selectDefaultColumn();
    }
  }

  convertToFlowsList(data) {
    let result: any = {};
    if (data.media.mediaType === 'PHONE') {
      result.uuid = data.uuid || '';
      result.name = data.description || '';
    }
    return result;
  }

  resetFilter() {
    this.filters = {};
    this.filters.phoneCallerFilter = '';
    this.filters.calledPhoneFilter = '';
    this.filters.calledPhoneAliasFilter = '';
    this.filters.flowFilter = '';
    this.filters.beginDateFilter = null;
    this.filters.endDateFilter = null;
    this.filters.durationFilter = '';

    this.endDateTime = new Date();
    this.beginDateTime = new Date();
    this.durationTime = 0;

    this.getRespMessagesList();
  }

  updateBeginDate() {
    this.beginDateTime.setHours(this.hoursBegin);
    this.beginDateTime.setMinutes(this.minutesBegin);
  }

  updateEndDate() {
    this.endDateTime.setHours(this.hoursEnd);
    this.endDateTime.setMinutes(this.minutesEnd);
  }

  // convertit le nb de minutes + nb de secondes saisis en millisecondes
  updateDuration() {
    this.durationTime = this.minutesDuration * 60000;
    this.durationTime = this.durationTime + this.secondsDuration * 1000;
  }

  removeRespMessage(row, index) {
    this.responder.deleteRespMessage([row.uuid]).then(
      data => this.removeProcessed(index, data),
      () => this.removeErrorOccured()
    );
  }

  removeProcessed(index, e) {
    this.rows.splice(index, 1);
    if (e) {
      this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'responder:toast.delete_success', ToastClass.RESPONDER, 1500);
    } else {
      this.removeErrorOccured();
    }
  }

  removeErrorOccured() {
    this.toastDeprecatedService.alert('responder:toast.delete_error');
  }

  refreshRespMessagesList() {
    this.getRespMessagesList();
  }

  getRespMessagesList() {
    if (this.firstSearch) {
      this.firstSearch = false;
      this.filters.beginDateFilter = this.beginDateTime;
    } else {
      if (this.hasBeginDate) {
        this.filters.beginDateFilter = this.beginDateTime;
      } else {
        this.filters.beginDateFilter = null;
      }
    }

    if (this.hasEndDate) {
      this.filters.endDateFilter = this.endDateTime;
    } else {
      this.filters.endDateFilter = null;
    }

    if (this.durationTime > 0) {
      this.filters.durationFilter = this.durationTime;
    } else {
      this.filters.durationFilter = null;
    }

    this.responder.execRespMessageRequest(this.filters, 10000, 0, this.flowsList).then(
      data => this.processSuccessList(data.data),
      () => this.processErrorList()
    );
  }

  processSuccessList(data) {
    this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'responder:toast.update_list_success', ToastClass.RESPONDER, 1500);

    this.rows = [];
    if (data) {
      for (let i = 0; i < data.hits.hits.length; i++) {
        if (data.hits.hits[i]._source !== null) {
          this.rows.push(this.convertToRespMessage(data.hits.hits[i]._source));
        }
      }
    }
  }

  processErrorList() {
    this.toastDeprecatedService.alert('responder:toast.update_list_error');
  }

  openArrayFilter() {
    this.columnFilterState = true;
  }

  openRespDetailModal(row) {
    this.modelRespDetail.date = row.date;
    if (row.callerNumber === undefined || row.callerNumber === null || row.callerNumber === '') {
      this.modelRespDetail.callerPhoneNumber = 'Anonymous';
    } else {
      this.modelRespDetail.callerPhoneNumber = row.callerNumber;
    }
    this.modelRespDetail.calledPhoneNumber = row.calledNumber;
    this.modelRespDetail.calledPhoneNumberAlias = row.calledNumberAlias;
    this.modelRespDetail.flow = row.flow;
    this.modelRespDetail.duration = row.duration;

    this.respDetailState = true;
  }

  formatRespMessageTime(milliseconds) {
    if (milliseconds && milliseconds !== null) {
      let seconds = milliseconds / 1000;

      let hours = parseInt((seconds / 3600).toString(), 10) % 24;
      let minutes = parseInt((seconds / 60).toString(), 10) % 60;
      let secs = parseInt((seconds % 60).toString(), 10);
      let result;
      let fragment = (minutes < 10 ? '0' + minutes : minutes) + ':' + (secs < 10 ? '0' + secs : secs);

      if (hours > 0) {
        result = (hours < 10 ? '0' + hours : hours) + ':' + fragment;
      } else {
        result = fragment;
      }
      return result;
    }
    return '';
  }

  convertToRespMessage(data) {
    let result: any = {};

    result.uuid = data.uuid || '';
    result.channelId = data.channelId || '';
    result.callerNumber = data.contactUri || '';
    result.calledNumber = data.calledUri || '';
    if (data.calledName && data.calledName !== 'null') {
      result.calledNumberAlias = data.calledName;
    } else {
      result.calledNumberAlias = '';
    }
    result.flow = data.mediaEntryPoint.description || '';
    result.date = data.beginDate || '';
    result.duration = data.messageDuration || '';
    result.formattedDuration = this.formatRespMessageTime(result.duration);
    result.readStatus = data.readStatus || '';

    return result;
  }

  selectDefaultColumn() {
    this.checked = 0;
    if (!this.columns) return;
    this.columns.forEach(column => {
      // keep selected selected
      if (column.displayed) {
        if (this.checked >= this.maxChecked) {
          column.displayed = false;
        } else {
          this.checked++;
        }
      }
    });
    // select other not selected for fill space
    if (this.checked < this.maxChecked) {
      this.columns.forEach(column => {
        if (!column.displayed) {
          if (this.checked < this.maxChecked) {
            column.displayed = true;
            this.checked++;
          } else {
            column.displayed = false;
          }
        }
      });
    }
  }

  // ------------------------------------------------------------------
  // Listen functions
  // ------------------------------------------------------------------

  openPlayer(row) {
    // rafraichissement lignes du tableau
    let channelId = row.channelId;

    this.responder.getRespMessageStatus(channelId).then(
      data => {
        // Success Callback
        let status = data.data;
        if (status === 'AVAILABLE' || status === 'IN_PROGRESS') {
          this.playRecord(row);
        } else if (status === 'ERROR') {
          this.toastDeprecatedService.alert('responder:toast.message_listen_error');
        } else {
          this.toastDeprecatedService.alert('responder:toast.message_not_available');
        }
      },
      () => this.toastDeprecatedService.alert('responder:toast.message_listen_error')
    );
  }

  private playRecord(row) {
    let audio: Audio = {
      title: '[' + row.callerNumber + '] ' + row.channelId,
      url: this.urlResp + row.channelId,
    };

    if (this.onAudioUpdated) this.onAudioUpdated({ $event: { audio } });

    this.responder.setRespMessageToRead([row.uuid]).then(
      () => (row.readStatus = 'READ'),
      () => this.toastDeprecatedService.alert('responder:toast.update_status_read_error')
    );
  }
}

export class ResponseMessageView implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    // from ui-bootstrap modal
    onAudioUpdated: '&',
  };
  controller = ['toastDeprecatedService', 'responder', 'recordDeprecatedService', ResponseMessageViewCtrl];
}

export default 'responseMessageView';
